module.exports = __webpack_public_path__ + "img/luwei.01c20260.png";